export default function destroySelectizes() {
  document.querySelectorAll('.selectized').forEach((element) => element.selectize?.destroy());
}

document.addEventListener('turbo:before-render', destroySelectizes);
document.addEventListener('turbo:before-cache', destroySelectizes);
